module.exports = __webpack_public_path__ + "static/media/icon-other.4cefff7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-other.svg
// module id = 562
// module chunks = 0